import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { GetSecondHandSuppliesOrdersByPkService } from '../services/get-second-hand-supplies-orders-by-pk.service';

@Injectable({
  providedIn: 'root'
})
export class GetSecondHandSuppliesOrdersByPkResolver implements Resolve<any> {
  constructor(private getSecondHandSuppliesOrdersByPkService: GetSecondHandSuppliesOrdersByPkService){

  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.getSecondHandSuppliesOrdersByPkService.getSecondHandSuppliesOrderByPk(route.paramMap.get("id"));
  }
}
